import React from 'react';
import { Page, PageHeader, PageBody } from "../base/Page";
import { Button, Row, Col, Panel, FormGroup, FormControl, ControlLabel } from 'react-bootstrap';
import API from "../base/API";
import { browserHistory } from "react-router";
import Auth from "../auth/Auth";
import { translate } from "../base/Translation";

export default class ErrorDBEdit extends Auth {

	constructor(props) {
		super(props);

		this.api = new API({
			save_error_db: "/error_db/save/:error_db",
			get_error_db: "/error_db/fetch/:error_db"
		});

		this.state = {
			error_db: null
		};
	}

	componentDidMount() {
		this.fetchData();
	}

	fetchData() {
		this.api.request({
			route: "get_error_db",
			params: { error_db: this.props.params.error_db_ID },
			success: (response) => {
				this.setState({ error_db: response });
			}
		});
	}

	onSave(evt) {
		this.api.request({
			route: "save_error_db",
			params: { error_db: this.props.params.error_db_ID },
			data: this.state.error_db,
			created: (response) => {
				browserHistory.push("/error_dbs");
			}
		});
	}

	onChange(evt) {
		// Get protocol from state
		let newErrorDB = this.state.error_db;

		// Update it's value
		newErrorDB[evt.target.name] = evt.target.value;

		// Update vehicle in state
		this.setState({ error_db: newErrorDB });
	}

	renderOptions(data) {
		let options = data.map(function (item) {
			return (
				<option value={item.id} key={item.id}>{typeof item.name !== "undefined" ? item.name : item.email}</option>
			)
		});

		return (options);
	}

	render() {

		if (this.state.error_db === null) {
			return (
				<Page>
					<PageHeader>{translate("Prosím počkajte")}</PageHeader>
					<PageBody>{translate("Obsah sa načítava")}</PageBody>
				</Page>
			);
		}

		return (
			<Page>
				<PageHeader title={this.state.error_db.name} />
				<PageBody>
					<Row>
						<Col lg={6}>
							<Panel header={translate("Základné")}>
								<FormGroup>
									<ControlLabel>{translate("Názov")}</ControlLabel>
									<FormControl defaultValue={this.state.error_db.name} name="name" onChange={this.onChange.bind(this)} />
								</FormGroup>
							</Panel>
						</Col>
					</Row>
					<Row>
						<Col lg={12}>
							<FormGroup>
								<Button bsStyle="success" onClick={this.onSave.bind(this)}>{translate("Uložiť")}</Button>
							</FormGroup>
						</Col>
					</Row>
				</PageBody>
			</Page>
		);
	}
}


// WEBPACK FOOTER //
// ./src/modules/error_db/ErrorDBEdit.js